var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUploadV2 = function SvgUploadV2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.206 17.287",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".upload-v2_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-v2_svg__upload",
    transform: "translate(-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-v2_svg__Gruppe_8236",
    "data-name": "Gruppe 8236",
    transform: "translate(19.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-v2_svg__Gruppe_8235",
    "data-name": "Gruppe 8235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upload-v2_svg__Pfad_16641",
    d: "M136.507 4.506 132.726.185a.54.54 0 0 0-.812 0l-3.781 4.322a.54.54 0 0 0 .406.9h2.161v7.023a.54.54 0 0 0 .54.54h2.16a.54.54 0 0 0 .54-.54V5.4h2.16a.54.54 0 0 0 .406-.9Z",
    className: "upload-v2_svg__cls-1",
    "data-name": "Pfad 16641",
    transform: "translate(-127.998)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "upload-v2_svg__Gruppe_8238",
    "data-name": "Gruppe 8238",
    transform: "translate(16 11.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-v2_svg__Gruppe_8237",
    "data-name": "Gruppe 8237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upload-v2_svg__Pfad_16642",
    d: "M30.045 352v3.241H18.161V352H16v4.322a1.08 1.08 0 0 0 1.08 1.08h14.046a1.08 1.08 0 0 0 1.08-1.08V352Z",
    className: "upload-v2_svg__cls-1",
    "data-name": "Pfad 16642",
    transform: "translate(-16 -352)"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUploadV2);
export default ForwardRef;